import { render, staticRenderFns } from "./Modulo10AntigoCheckbox.vue?vue&type=template&id=17435a38&scoped=true&"
import script from "./Modulo10AntigoCheckbox.vue?vue&type=script&lang=js&"
export * from "./Modulo10AntigoCheckbox.vue?vue&type=script&lang=js&"
import style0 from "./Modulo10AntigoCheckbox.vue?vue&type=style&index=0&id=17435a38&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17435a38",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VCheckbox,VProgressCircular})
